<template >
  <v-sheet
    style="background: #ffffff00"
    class="fill-height d-flex justify-space-around"
  >
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>
    <v-overlay opacity="0">
      <v-card v-if="!successful" style="max-width: 350px" color="#ffffff00" elevation="0" class="mt-0">
        <v-img
          class="mt-0"
          src="../assets/flat.png"
          height="200"
          contain
          >
        </v-img>
        <h5 class="text-center subtitle-1 grey--text font-weight-normal">
          Enter your email below and you'll receive a link to reset your password.
        </h5>
        <v-form fluid ref="form" v-model="valid" lazy-validation name="form">
          <v-container>
            <v-text-field
              light
              color="#2A353D"
              prepend-inner-icon="mdi-email"
              v-model="user.Email"
              label="Email"
              outlined
              required
              :rules="emailRules"
            ></v-text-field>
            <v-btn v-if="!successful" :disabled="!valid" @click="loading = true; submit()" class="btn btn-primary btn-block" color="#2A353D">
              <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
              <span class="white--text font-weight-bold">Submit</span>
            </v-btn>
          </v-container>
        </v-form>
      </v-card>
      <v-card v-else style="max-width: 350px" color="#ffffff00" elevation="0" class="mt-0">
        <v-img
          class="mt-0"
          src="../assets/flat.png"
          height="200"
          contain
          >
        </v-img>
        <h5 class="text-center subtitle-1 grey--text font-weight-normal">
          A link to reset your password was sent to your email. Please check your inbox
        </h5>
        <v-btn class="mt-12" color="#2A353D" block @click="$router.push('/login')">GO TO LOGIN</v-btn>
      </v-card>
    </v-overlay>
  </v-sheet>
</template>

<script>
import AuthService from '../services/auth.service';

export default {

  data() {
    return {
      loading: false,
      user: {},
      message: '',
      valid: true,
      successful: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    };
  },

  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },

  created() {
    if (this.loggedIn) {
      this.$router.push('/home');
    }
  },

  methods: {
    async submit () {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        AuthService.forgotPassword(this.user)
        .then(response => {
          this.message = response.data.message;
          this.loading = false;
          this.successful = true;
          this.reset()
          // this.close()
        },
        error => {
          this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.successful = false;
          this.loading = false;
        })
      }
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
    },

    reset () {
      this.$refs.form.reset()
    },
  },
};
</script>

<style scoped>

#ChangePwd {
  background-color: white;
}

.text {
  color: #1C284E;
}

.v-btn {
  outline: none
}

</style>